import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

function normalizeLanguage(language) {
  const value = String(language || '').toLowerCase();
  if (value.startsWith('zh')) return 'zh';
  return 'en';
}

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();
  const selectedLanguage = normalizeLanguage(i18n.resolvedLanguage || i18n.language);

  useEffect(() => {
    document.documentElement.lang = selectedLanguage === 'zh' ? 'zh-Hans' : 'en';
  }, [selectedLanguage]);

  const handleLanguageChange = (e) => {
    const next = e.target.value === 'zh' ? 'zh-Hans' : 'en';
    i18n.changeLanguage(next);
  };

  return (
    <label className="language-switcher" aria-label={t('language.label')}>
      <span className="language-switcher-text">{t('language.short')}</span>
      <select
        onChange={handleLanguageChange}
        value={selectedLanguage}
        className="language-switcher-dropdown"
      >
        <option value="en">{t('language.english')}</option>
        <option value="zh">{t('language.chinese')}</option>
      </select>
    </label>
  );
};

export default LanguageSwitcher;
